import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssFontSize, cssSpacing } from "../../util/styles.js";
import {
  Card as BaseCard,
  CardBody,
  CardMedia,
} from "../../internal-components/Card.js";

export const KarusellHeading = styled.h2`
  margin: 0 0 ${cssSpacing("m")};
  color: var(--karusell-title-color, inherit);
  font-size: ${cssFontSize("large")};

  @media (min-width: ${mobileBreakPointCSS}) {
    font-size: ${cssFontSize("larger")};
  }
`;

export const KarusellTrack = styled.div`
  display: flex;
  gap: ${cssSpacing("s")};
  overflow-x: scroll;
  padding: 0 10px ${cssSpacing("s")};
  scroll-padding-left: 10px;
  scroll-snap-type: x mandatory;
  scrollbar-color: var(--karusell-scrollbar-color) var(--karusell-scrollbar-track-color);
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: var(--karusell-scrollbar-track-color);
  }

  &::-webkit-scrollbar-thumb {
    background: var(--karusell-scrollbar-color);
    border-radius: 2px;
  }
`;

export const KarusellCard = styled(BaseCard).attrs({
  $background: "var(--karusell-card-background)",
})<{ href?: string }>`
  flex: 0 0 260px;
  scroll-snap-align: start;

  @media (min-width: ${mobileBreakPointCSS}) {
    flex: 0 0 280px;
  }
`;

export const KarusellCardImage = styled(CardMedia).attrs({
  $height: "180px",
})``;

export const KarusellCardBody = styled(CardBody)`
  display: flex;
  flex-direction: column;
  gap: ${cssSpacing("xs")};
  flex: 1;
`;

export const KarusellCardTitle = styled.span`
  display: block;
  color: var(--karusell-card-title-color, inherit);
  font-size: ${cssFontSize("small")};
  font-weight: 700;
  line-height: 1.4;
`;

export const KarusellCardText = styled.p`
  margin: 0;
  color: var(--karusell-card-description-color, inherit);
  font-size: ${cssFontSize("tiny")};
  line-height: 1.5;
`;

export const KarusellArrows = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${cssSpacing("xs")};
  padding: 0 10px;
`;

export const KarusellArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: var(--karusell-arrow-background);
  flex-shrink: 0;

  &[data-active="true"] {
    background: var(--karusell-arrow-active-background);
  }

  &:hover {
    opacity: 0.85;
  }

  svg {
    display: block;
    width: 18px;
    height: 18px;
    fill: none;
  }

  svg path {
    fill: none;
    stroke: var(--karusell-arrow-icon-color);
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  &[data-active="true"] svg path {
    stroke: var(--karusell-arrow-active-icon-color);
  }
`;
